import type { AtlasSuggestionsContext } from "@intelligems/ig-types/functions/agentic-logic/atlas-suggestions/atlas-suggestions";

import type { AgenticLogicView } from "../surface/ruleViewParams";
import type { RuleDetailTabKey } from "../workspace/ruleDetailTabs";

/**
 * What the agentic-logic rail's context chips are about, for the view on
 * screen: the rule and its tab on a rule's workspace, the rules list on the
 * list. The creation view has none — a rule being created is the
 * conversation itself, and the embedded creation view offers the store's rule
 * ideas instead (`AtlasSuggestionChips`).
 */
export const resolveAtlasRailSuggestionContext = (
  view: AgenticLogicView,
  tab: RuleDetailTabKey
): AtlasSuggestionsContext | null => {
  switch (view.kind) {
    case "rule":
      return { surface: "rule", ruleId: view.ruleId, tab };
    case "list":
      return { surface: "rules" };
    case "new":
      return null;
  }
};
